import React, { Component } from "react";
import PropTypes from "prop-types";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import formValueSelector from "redux-form/lib/formValueSelector";

import StepBox from "../StepBox";
import CustomerDetails from "./CustomerDetails";
import isEqual from "lodash/isEqual";

/**
 * CustomerDetailsStep
 */
class CustomerDetailsStep extends Component {
  static propTypes = {
    step: PropTypes.number,
    onNextStep: PropTypes.func.isRequired,
    isActive: PropTypes.bool,
    isValid: PropTypes.bool,
    isOpen: PropTypes.bool,
    hasOverview: PropTypes.bool,
    t: PropTypes.func.isRequired
  };

  static defaultProps = {
    step: null,
    isActive: false,
    isValid: false,
    isOpen: false,
    hasOverview: false
  };

  shouldComponentUpdate(nextProps) {
    // for some reason this does not work in the connect() "areMergedPropsEqual" option
    return !isEqual(this.props, nextProps);
  }

  render() {
    return (
      <StepBox
        number={this.props.step}
        title={this.props.t("Your details / invoice address")}
        isActive={this.props.isActive}
        isOpen={this.props.isOpen}
        isValid={this.props.isValid}
        onNextStep={this.props.onNextStep}
        hasOverview={this.props.hasOverview}
      >
        <div className="row">
          <CustomerDetails className="col-12" />
        </div>
      </StepBox>
    );
  }
}

const valueSelector = formValueSelector("cart");
export default translate()(
  connect(state => ({
    hasEmailAddress: !!valueSelector(state, "customer.emailAddress")
  }))(CustomerDetailsStep)
);
